"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _coreContainer = _interopRequireDefault(require("@vfuk/core-container"));
var _coreHeading = _interopRequireDefault(require("@vfuk/core-heading"));
var _coreButton = _interopRequireDefault(require("@vfuk/core-button"));
var _coreIcon = _interopRequireDefault(require("@vfuk/core-icon"));
var _coreInteractiveIcon = _interopRequireDefault(require("@vfuk/core-interactive-icon"));
var _coreBaseProps = require("@vfuk/core-base-props");
var _coreThemes = require("@vfuk/core-themes");
var Styled = _interopRequireWildcard(require("./styles/AlertNotification.style"));
var _AlertNotification2 = _interopRequireDefault(require("./themes/AlertNotification.theme"));
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var AlertNotification = function AlertNotification(_ref) {
  var _ref$appearance = _ref.appearance,
    appearance = _ref$appearance === void 0 ? 'primary' : _ref$appearance,
    _ref$srAlert = _ref.srAlert,
    srAlert = _ref$srAlert === void 0 ? true : _ref$srAlert,
    state = _ref.state,
    closeButton = _ref.closeButton,
    heading = _ref.heading,
    children = _ref.children,
    button = _ref.button,
    id = _ref.id,
    dataSelectorPrefix = _ref.dataSelectorPrefix,
    dataAttributes = _ref.dataAttributes,
    localTheme = _ref.localTheme;
  var componentName = 'AlertNotification';
  var alertNotificationTheme = (0, _coreThemes.useLocalTheme)(componentName, _AlertNotification2["default"], localTheme);
  var stateMaptoContainer = state === 'success' ? 'selected' : state;
  var _alertNotificationThe = alertNotificationTheme.appearance[appearance],
    containerAppearance = _alertNotificationThe.containerAppearance,
    buttonAppearance = _alertNotificationThe.buttonAppearance,
    inverseText = _alertNotificationThe.inverseText,
    inverseIcon = _alertNotificationThe.inverseIcon;
  var getIconName = function getIconName() {
    return "".concat(state, "-inverse");
  };
  return /*#__PURE__*/_react["default"].createElement(_coreContainer["default"], {
    appearance: containerAppearance,
    state: stateMaptoContainer,
    allowOverflow: false,
    paddingLevel: 0,
    id: id,
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix),
    componentName: componentName,
    dataAttributes: dataAttributes
  }, /*#__PURE__*/_react["default"].createElement(Styled.AlertNotification, {
    "aria-live": srAlert ? 'assertive' : 'off',
    "aria-atomic": srAlert
  }, /*#__PURE__*/_react["default"].createElement(Styled.IconWrapper, {
    state: state
  }, /*#__PURE__*/_react["default"].createElement(Styled.NotificationHeader, {
    closeButton: closeButton
  }, /*#__PURE__*/_react["default"].createElement(_coreIcon["default"], {
    name: getIconName(),
    group: "state",
    size: 3,
    isResponsive: true,
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, 'icon'),
    inverse: inverseIcon
  })), closeButton && /*#__PURE__*/_react["default"].createElement(Styled.CloseButton, null, /*#__PURE__*/_react["default"].createElement(_coreInteractiveIcon["default"], {
    srText: closeButton.srText,
    name: "close",
    inverse: true,
    size: 2,
    onClick: closeButton.onClick,
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, 'close-icon')
  }))), /*#__PURE__*/_react["default"].createElement(Styled.NotificationWrapper, null, /*#__PURE__*/_react["default"].createElement(Styled.ContentWrapper, null, (heading === null || heading === void 0 ? void 0 : heading.text) && /*#__PURE__*/_react["default"].createElement(_coreHeading["default"], _extends({}, heading, {
    size: 1,
    weight: 3,
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, 'heading'),
    inverse: inverseText
  })), children, button && /*#__PURE__*/_react["default"].createElement(Styled.ButtonWrapper, null, /*#__PURE__*/_react["default"].createElement(_coreButton["default"], _extends({
    appearance: buttonAppearance
  }, button, {
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, 'button')
  })))))));
};
AlertNotification.displayName = "AlertNotification";
var _default = AlertNotification;
exports["default"] = _default;